var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiDrawer from '@material-ui/core/Drawer';
/**
 * Navigation drawers provide access to destinations in your app.
 * Side sheets are surfaces containing supplementary content that are anchored to the left or right edge of the screen.
 *
 * Kareo wrapped component of the Material-UI Drawer. The prop API has been limited to props defined in DrawerProps.
 *
 * References: [Navigation Drawers](https://material.io/components/navigation-drawer), [Side Sheets](https://material.io/components/sheets-side)
 *
 * Material-UI Drawer: [Docs](https://v4.mui.com/components/drawers/), [API](https://v4.mui.com/api/drawer/)
 *
 * @storybook: [Drawer](http://design.kareoprod.ent/design-system/?path=/story/components-data-display-badge--badge-example)
 */
var Drawer = React.forwardRef(function (props, ref) {
    return React.createElement(MuiDrawer, __assign({ ref: ref }, props));
});
Drawer.displayName = 'KareoDrawer';
export default Drawer;
